import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../layout/loader/loader.component';
import { FormsModule } from '@angular/forms';
import { ModalHeaderComponent } from '../modals/modal-header/modal-header.component';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-teacher-information-form',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    LoaderComponent,
    ModalHeaderComponent
  ],
  templateUrl: './teacher-information-form.component.html',
  styleUrl: './teacher-information-form.component.scss'
})
export class TeacherInformationFormComponent implements OnInit {
  @Input() itemId: string = '';
  @Input() organisationId: string = '';

  public availableRoles = ['teacher'];

  _item: any = {};
  @Input()
  set item(value: any) {
    this._item = value;
    this.onItemSet(value);
  }

  get item() {
    return this._item;
  }

  onItemSet(item: any) {
    if (this.item['id']) {
      this.modalTitle = 'Wijzig docent';
    } else {
      this.modalTitle = 'Docent toevoegen';
    }
  }

  organisations: any = [];
  roles: any = [];
  errorMessage: any = {};
  errors: any = {};
  loading: boolean = false;
  newPassword: string = '';

  modalTitle: string = 'Docent toevoegen';
  modalStyle: boolean = false;

  constructor(
    private apiService: ApiService,
    private activeModal: NgbActiveModal
  ) {
    this.getOrganisations();
    this.getRoles();
    this.getItem();
  }

  ngOnInit() {
    this.getItem();
    this.getOrganisations();
    this.getRoles();
  }

  save() {
    let self = this;

    self.reset();
    self.loading = true;

    const modal = document.querySelector('.modal');
    if (modal) {
      modal.scrollTo({ top: 0, behavior: 'smooth' });
    }

    if (this.item['id'] == undefined) {
      let postData = this.item;
      postData['password'] = self.newPassword;

      return this.apiService.post('/office/users', postData).then(function (response: any) {
        self.handleSucces(response);
      }).catch(function (e) {
        self.handleError(e);
      });
    }
    else {
      let postData = this.item;
      postData['password'] = self.newPassword;

      return this.apiService.put('/office/users/' + this.item['id'], postData).then(function (response: any) {
        self.handleSucces(response);
      }).catch(function (e) {
        self.handleError(e);
      });
    }
  }

  handleSucces(response: any) {
    let self = this;
    self.item = response;
    setTimeout(function () {
      self.loading = false;
      self.activeModal.close(true);
    }, 200);
  }

  handleError(response: any) {
    let self = this;
    self.errors = response['error']['error'];
    self.errorMessage = response['error']['message'];
    self.loading = false;

    if (response.status == 500) {
      self.errorMessage = response['error']['message'];
      self.errors = [];
    }
  }

  reset() {
    this.errors = {};
    this.errorMessage = '';
  }

  getOrganisations() {
    let self = this;

    return this.apiService.get('/office/organisations').then(function (response: any) {
      self.organisations = response['data'];
    }).catch(function (e) { });
  }

  getRoles() {
    let self = this;

    return this.apiService.get('/office/roles').then(function (response: any) {
      self.roles = response['data'];
      console.log(self.roles)
    }).catch(function (e) { });
  }

  getItem() {
    let itemId = this.itemId;
    let self = this;

    self.reset();
    if (this.itemId === '') {
      self.item['organisation_id'] = self.organisationId;
      console.log(self.organisationId)
      console.log(self.item)
      return;
    }
    return this.apiService.get('/office/users/' + itemId).then(function (response: any) {
      self.item = response['data'];
      if (self.item['id']) {
        self.modalTitle = 'Wijzig docent';
      } else {
        self.modalTitle = 'Docent toevoegen';
        self.item['organisation_id'] = self.organisationId;
      }
      setTimeout(function () { self.loading = false; }, 200);
    }).catch(function (e) {
      self.loading = false;
    });
  }
}
